module.exports = __webpack_public_path__ + "static/media/season-pass-logo.8149d248.svg";